export default {
  path: '/2019GoldenFoodAnnualList',
  name: 'GoldenFoodAnnualList2019',
  component: () => import('./home.vue'),
  base: '/2019GoldenFoodAnnualList/',
  meta: {
    title: '第二届“重庆美食年度金榜”大型融媒体评选活动',
  },
  children: [
    {
      path: 'List',
      component: () => import('./List.vue'),
      name: 'GoldenFoodAnnualList',
      meta: {
        title: '第二届“重庆美食年度金榜”大型融媒体评选活动',
      },
    },
    {
      path: 'Register',
      component: () => import('./Register.vue'),
      name: 'GoldenFoodAnnualListRegister',
      meta: {
        title: '第二届“重庆美食年度金榜”大型融媒体评选活动',
      },
    },
    {
      path: 'FirstPage',
      component: () => import('./FirstPage.vue'),
      name: 'GoldenFoodAnnualListFirstPage',
      meta: {
        title: '第二届“重庆美食年度金榜”大型融媒体评选活动',
      },
    },
    {
      path: 'DetailPage',
      component: () => import('./DetailPage.vue'),
      name: 'GoldenFoodAnnualListDetailPage',
      meta: {
        title: '第二届“重庆美食年度金榜”大型融媒体评选活动',
      },
    },
    {
      path: 'Rules',
      component: () => import('./Rules.vue'),
      name: 'GoldenFoodAnnualListRules',
      meta: {
        title: '第二届“重庆美食年度金榜”大型融媒体评选活动',
      },
    },
  ],
};
